import { Container, FormControl, Grid, InputLabel, MenuItem, Select, makeStyles, Typography, TextField, Button, CircularProgress, Snackbar, Breadcrumbs } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MuiAlert from "@material-ui/lab/Alert";
import { withFirebase } from "../Firebase";
import { withAuthorization } from "../Session";
import { Link, useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { Home } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";

const subjects = ["solicitar_información", "informar_de_un_error"];
const INITIAL_STATE = { message: "", selectedSubjet: 0 };

const ReportPage = (props) => {
  const { firebase } = props;
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const [selectedSubjet, setSelectedSubjet] = useState(INITIAL_STATE.selectedSubjet);
  const [message, setMessage] = useState(INITIAL_STATE.message);
  const [isSenddingEmail, setIsSenddingEmail] = useState(false);
  const [isActionDone, setIsActionDone] = useState(false);
  const [sendingEmailResult, setSendingEmailResult] = useState(-1);

  const handleSubjetChange = (e) => setSelectedSubjet(e.target.value);

  const handlemessageChange = (e) => setMessage(e.target.value);

  const sendMessage = () => {
    setIsSenddingEmail(true);
    let jsonInfo = {
      subject: `Reanibex Training |  ${t(subjects[selectedSubjet])}`,
      message: `Se ha enviado un nuevo reporte del usuario: ${
        firebase.currentUser().email
      } <----->\n el contenido del mensaje es: ${message} <-----> \n Para contestar a su solicitud escribirle un email a su cuenta de correo ${firebase.currentUser().email}`,
    };

    firebase
      .sendReport(jsonInfo)
      .then(() => {
        setSendingEmailResult(0);
        setIsActionDone(true);
        setIsSenddingEmail(false);
        setMessage(INITIAL_STATE.message);
        setSelectedSubjet(INITIAL_STATE.selectedSubjet);
      })
      .catch((err) => {
        setSendingEmailResult(1);
        setIsActionDone(true);
        setIsSenddingEmail(false);
      });
  };

  return (
    <Grid container justify="center" spacing={3} style={{ marginTop: 42 }}>
      <Grid container item xs={12} lg={7} className={styles.headerContainer}>
        <Breadcrumbs className={styles.breadcrumbs}>
          <Link
            color="inherit"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push(ROUTES.HOME);
              window.scrollTo(0, 0);
            }}
          >
            <div style={{ display: "flex" }}>
              <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
              <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
            </div>
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={11} md={8} lg={7}>
        <Typography variant="h1" className={styles.mainTitle}>
          {t("contactar_con_servicio_de_atención_al_cliente")}
        </Typography>
      </Grid>
      <Grid item xs={11} md={8} lg={7}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-outlined-label">{t("motivo_del_mensaje")}</InputLabel>
          <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={selectedSubjet} onChange={handleSubjetChange} label={t("motivo_del_mensaje")}>
            {subjects.map((k, i) => (
              <MenuItem key={i} value={i}>
                {t(k)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={11} md={8} lg={7}>
        <TextField
          fullWidth
          id="outlined-textarea"
          value={message}
          onChange={handlemessageChange}
          label={t("mensaje")}
          placeholder={t("escribe_aquí_el_contenido_del_mensaje")}
          multiline
          variant="outlined"
          rows={12}
        />
      </Grid>
      <Grid item xs={11} md={8} lg={7} container justify="flex-end" spacing={2}>
        <Grid item>
          <Button variant="outlined" style={{ textTransform: "none", backgroundColor: red[400], color: "white" }} onClick={() => history.goBack()}>
            {t("cancelar")}
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" style={{ textTransform: "none" }} disabled={message == "" || isSenddingEmail} onClick={sendMessage}>
            {isSenddingEmail && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
            {t("enviar")}
          </Button>
        </Grid>
      </Grid>
      <Snackbar open={isActionDone} autoHideDuration={6000} onClose={() => setIsActionDone(false)}>
        <Alert onClose={() => setIsActionDone(false)} severity={sendingEmailResult == 0 ? "success" : "error"}>
          {sendingEmailResult == 0 ? t("se_ha_enviado_el_mensaje_correctamente") : t("no_se_ha_procesado_la_solicitud")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(ReportPage);

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",
    marginBottom: 8,
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("sm")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },
}));
